import { Box, styled } from '@mui/material';

const Wrapper = styled(Box)`
  min-height: 100%;
  display: flex;

  gap: 3rem;
`;

export default Wrapper;
